<template>
  <div class="internal">
    <div class="container">
      <h1>Terms of Use</h1>
      <hr />
      <ol>
        <li>
          <h5>Introduction</h5>
          <p>This website, www.seascaffolding.co.uk is operated and maintained by SEA Scaffolding(&ldquo;we&rdquo;, &ldquo;us&rdquo; or &ldquo;our&rdquo;). The following Terms of Use apply to all visitors to, or users of this website.</p>
          <p>By using this website you agree to be bound by these Terms of Use. If you do not accept these terms, you may not use this website.</p>
          <p>We reserve the right to change the contents of this website, including these Terms of Use, at any time without notice by posting such changes on the website. It is your responsibility to familiarise yourself with these terms to ensure that you are aware of any changes. Your use of this website following the posting of any such changes will constitute your acceptance of the revised Terms of Use.</p>
        </li>

        <li>
          <h5>Rights and Restrictions</h5>
          <p>2.1 The copyright and other intellectual property rights in all materials on this website are owned by us (or its licensors).</p>
          <p>2.2 The trademarks, logos and service marks displayed on this Website (&ldquo;Marks&rdquo;) belong to us or other third parties. You are not permitted to use these Marks without our prior written consent or such third party which may own the Marks.</p>
          <p>2.3 You may copy materials published on this website solely for your own personal information and non-commercial use. You may not modify, distribute, publish, transmit, reproduce, store or create derivative works of any material or content on this website.</p>
        </li>

        <li>
          <h5>Disclaimer</h5>
          <p>3.1 Care is taken to ensure that the information contained on this website is current and accurate; however, you acknowledge that this is provided for information purposes only and is subject to change at any time. We do not accept responsibility for any errors, inaccuracies or omissions with respect to the information and material on this website.</p>
          <p>3.2 Whilst we make every effort to ensure this website is available and secure, given the nature of the Internet, we do not guarantee this will always be the case.</p>
          <p>3.3 We do not guarantee that this website will be uninterrupted or error free, or free from viruses or other harmful components. You are recommended to take all appropriate safeguards before downloading any information or content from this website.</p>
          <p>3.4 Save as precluded by law, we shall not be liable to you or any person for any loss or damage which may arise from the use or misuse of this website or any of the information or materials on the website. We accept no liability whatsoever under contract, tort or otherwise for any indirect, incidental, special, punitive or consequential loss, damage or expenses (including without limitation any loss of revenue, profits, contracts, anticipated savings, wasted expenditure, data or goodwill).</p>
          <p>3.5 Nothing in these Terms of Use excludes our liability to you for personal injury or death caused by our negligence.</p>
        </li>

        <li>
          <h5>Third Party Sites</h5>
          <p>This website includes links to third party web sites. We will not be responsible for the availability, content, information, security or for any products or services available from such third party sites. You should always check the terms and conditions and privacy statements of those third party sites.</p>
        </li>

        <li>
          <h5>Privacy</h5>
          <p>Any information that we receive from you via this website will be used and held by us in accordance with our Privacy Policy.</p>
        </li>

        <li>
          <h5>Miscellaneous</h5>
          <p>6.1 Invalidity &ndash; If any of the terms of these Terms of Use are deemed invalid, void or unenforceable for any reason, they will be severed from the rest of these Terms of Use which shall remain unaffected.</p>
          <p>6.2 Entire Agreement &ndash; these Terms of Use represent the entire understanding between us and you relating to the use of this website and supersede all other statements, representation or warranties (whether written, made by email or oral) made by us. Any rights not expressly granted in these Terms of Use are reserved by us.</p>
          <p>6.3 Governing law and jurisdiction &ndash; These Terms of Use shall be governed by and construed in accordance with English law. Any disputes arising in connection with these terms shall be subject to the exclusive jurisdiction of the English courts.</p>
          <p>6.4 Contact Details</p>
          <p>SEA Scaffolding</p>
          <p>
            Registered office: Unit 5b Site 2,
            Sandpit Lane,
            Worlingham,
            Beccles,
            Suffolk,
            NR347TH
          </p>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsOfUse"
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/TermsOfUse.vue